import { useEffect } from "react";
import { reportedByMe } from "../../store/api/workItemsApi";
import { useDispatch, useSelector } from "react-redux";
import BihamtaTable from "../../../Components/BihamtaTable";
import { convertFromMoment } from "../../../store/api/CommonFunctions";
import { useHistory } from "react-router-dom";
import { fixDateFilters, getTableColumns } from "./helper";
import SearchFilters from "./SearchFilters";
import ExcelButton from "./ExcelButton";

export default function ReportedByMe({ type, isActive }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const filterData = useSelector(state => fixDateFilters(state.workItems.workItemsRepByMeFilters));

    const search = (data) => {
        if (data) {
            data.CreationDateFrom = convertFromMoment(data.CreationDateFrom).date;
            data.CreationDateTo = convertFromMoment(data.CreationDateTo).date;
        }
        dispatch(reportedByMe({ ...data, Take: data?.Take ?? 10, Skip: data?.Skip ?? 0 }));
    }
    const gotoWi = (row) => {
        if (row.ctrlIsDown) {
            window.open(`/Projects/CreateEditWorkItem/false/${row.ID}`, '_blank');
        }
        else {
            history.push(`/Projects/CreateEditWorkItem/false/${row.ID}`);
        }
    }
    useEffect(() => {
        if (isActive)
            search(filterData);
    }, [type, isActive])

    return (
        <>
            <SearchFilters defaultValues={filterData} onSubmit={search} />
            <div style={{ display: "flex", justifyContent: "end" }}>
                <ExcelButton actionUrl="ReportedByMe" filterData={filterData} tableCols={getTableColumns(type)} />
            </div>
            <BihamtaTable
                columns={getTableColumns(type)}
                className="mt-0"
                objectName="workItemsRepByMe"
                reducerName="workItems"
                pageSizeList={[10, 20, 50, 100, 900]}
                hasPaging={true}
                filterData={filterData}
                rowClick={gotoWi}
                searchMethod={data => dispatch(reportedByMe(data))} /></>
    )
}